
    import {Inject, Options, Vue} from 'vue-property-decorator';
    import TagsSelection from '@/profile-creation-wizard/components/for-creation/ui/3_expertise/skills/TagsSelection.vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {CreationFormValidation} from '@/profile-creation-wizard/components/for-creation/ProfileCreationForm';
    import {ProfileCreationService} from '@/profile-creation-wizard/components/for-creation/ProfileCreationService';
    import {Getter} from 'vuex-class';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import {TrackingRepository} from '@/common/repositories/track/TrackingRepository';
    import MaltClassicExpertiseSide from '@/profile-creation-wizard/components/for-creation/ui/3_expertise/MaltClassicExpertiseSide.vue';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import {ProfileCreationForm} from '@/profile-creation-wizard/types';
    import {RouteRecordNameGeneric} from 'vue-router';

    @Options({
        components: {
            Step,
            MaltClassicExpertiseSide,
            TagsSelection,
        },
    })
    export default class MaltClassicExpertiseStep extends Vue {
        @Inject({from: DI.creationFormValidation})
        creationFormValidation!: CreationFormValidation;
        @Inject({from: DI.profileCreationService})
        profileCreationService!: ProfileCreationService;
        @Inject({from: DI.trackingRepository})
        trackingRepository!: TrackingRepository;
        @Getter(getters.creationForm)
        creationForm!: ProfileCreationForm;

        mounted(): void {
            window.scrollTo({
                top: 0,
            });
        }

        created(): void {
            if (window.hj) {
                // Custom event Hotjar
                window.hj('event', 'profile_creation_details_page');
            }
        }

        get hasValidFieldPart(): boolean {
            const form = this.creationForm;

            return this.creationFormValidation.isTagsValid(form.tags);
        }

        goNext(): void {
            this.trackingRepository.track('expertise-chosen-skills-freelancer', {
                skills: this.creationForm.tags.map((tag) => tag.name),
            });

            this.$router.push({name: this.$router.currentRoute.value.meta.nextStep as RouteRecordNameGeneric});
        }
    }
